import React from "react";

const CustomerDashboard = () => {
  return <div>Dashboard</div>;
};

export default CustomerDashboard;
